import { stringify } from 'querystring'

const doFetch = async (method, endpoint, body, params) => {
  let url = process.env.API_URL + '/v1' + endpoint
  if (params) {
    url = url + '?' + stringify(params)
  }

  const res = await fetch(url, {
    method: method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Voicemachine-Service': 'admin',
      Authorization: `Bearer ${process.env.API_KEY}`
    },
    body: body ? JSON.stringify(body) : null
  })

  const json = await res.json()

  if (!res.ok) {
    throw new Error(json.error)
  }

  return json
}

export const get = (url, params) => doFetch('GET', url, null, params)
export const post = (url, data) => doFetch('POST', url, data)
export const patch = (url, data) => doFetch('PATCH', url, data)
export const put = (url, data) => doFetch('PUT', url, data)
export const del = (url, data) => doFetch('DELETE', url, data)
